<template>
  <!--  v-on:click="checkModule" -->
  <div class="com-item" :key="index">
    <div class="component person-nav"  :style="{
          backgroundColor: modata.WContent.bgColor || 'transparent',
          color: modata.WContent.textColor || '#333'
        }">

      <div class="van-sticky" >

        <div class="titleModule">
          <titleModule v-bind:modata="modata"></titleModule>
        </div>
        <div class="video-list">
          <div class="video-item" v-for="(item, index) in modata.WContent.list">

            <div class="video-seat" @click="handPlay(index)">
              <div class="cover">
                <video style='width:100%;height:100%;' :autoplay="false" :poster="item.poster" :src="item.videoUrl"></video>
                <div class="playType2 center icon_play">
                  <span class="v-icon">
                    <i class="el-icon-caret-right i-pause"></i>
                  </span>
                </div>

              </div>
            </div>
            <div class="title">{{ item.title }}</div>
          </div>
        </div>


         <div class="center carrousel" v-if="carrouselTogle">
              <!-- <span class="entypo-cancel" v-on:click="closeFile"></span> -->
              <div class="wrapper">
                  <video :src="carrouselUrl" ref="video" controls="controls" style="width:100%;"></video>
                   <div class="plyr__controls"  v-on:click="handleClose" >关闭视频</div>
              </div>
              
          </div>
      



      </div>
    </div>
  </div>

</template>

<script>
import titleModule from "@/components/Custom/Title";
export default {
  name: "videolist-module",
  components: { titleModule },
  props: {
    type: {
      //展示类型 preview预览模块 setting设置模块
      type: String,
      default: "preview",
    },
    index: {
      //索引
      type: Number,
    },
    proportion: {
      type: Number,
      default: 1,
    },
    modata: {
      type: Object,
      // 对象或数组默认值必须从一个工厂函数获取
      default: function () {
        return {
          WName: "video",
          Title: "视频列表",
          WID: 1,
          ModuleName: "video-module",
          WContent: {
            
          },
          WHtml: "",


        };
      },
    },
  },
  data() {
    return {
      playStatus: false,
      currType: 1,

      rootValue: this.$store.state.rootValue || 1,

      carrouselUrl:"",
      carrouselTogle:false,
    };
  },
  mounted() {


  },
  beforeDestroy() { },
  methods: {

    handPlay(index) {
      this.carrouselUrl=this.modata.WContent.list[index].videoUrl;
      if(!this.carrouselUrl){
        return
      }
      this.carrouselTogle=true;
      this.$nextTick(()=>{
         this.$refs.video.play();
      })
   
    },

    handleClose() {
    //  this.$refs.video.pause();
     this.carrouselTogle=false;
    },

  },

  watch: {},
};
</script>

<style scoped>
.van-sticky {
  padding: 3% 0 1%;
  max-width: 1600px;
  width: 94%;
  margin: auto;
}
.titleModule{
  margin-bottom: 3%;
}

.video-list {
  display: flex;
  flex-flow: row wrap;

  .video-item {
   width: 33.33%;
    text-align: center;
    cursor: pointer;

  }
  .video-item {
    margin-bottom: 3%;
  }


  .title{
    line-height: 1;
    display-radio: 1;
    font_radio: 2;
    font-size: 17px;
    text-align: center;
    color: rgba(0, 0, 0, 0.8);
    margin-top: 20px;
    margin-bottom: 0px;
  }

  .video-seat {
    padding-bottom: 62%;
    background-color: #fff;
    position: relative;
    width: 94%;
    margin: 0 auto;
  }
  .video-seat:hover .playType2{
    opacity: 1;
  }

  .cover {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  video {
    width: 100%;
    height: 100%;
    background-color: #000;
  }

}


.playType2{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: all ease .3s;
  background-color:rgba(0,0,0,0.5);
  opacity: 0;
}


.v-icon {
  opacity: 0.9;
  display: inline-block;
  width: 56px;
  height: 56px;
  color: #fff;
  border: solid 2px #fff;
  border-radius: 30px;
  text-align: center;
  cursor: pointer;
}
.i-pause{
  font-size: 30px;
  line-height: 50px;
}



/* 播放 */

  .carrousel {
      margin: auto;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      position: fixed;
      z-index: 10;
      background-color: rgba(10, 10, 10, 0.8);
      padding-bottom:80px;
  }

    .carrousel .wrapper {
        width: 100%;
        max-width:730px;
        overflow: hidden;
        margin: auto;
    }

    .carrousel .wrapper video {
       width: 100%;
       height: auto;
    }

    .plyr__controls{
      max-width: 150px;
      background: #fff;
      margin: 30px auto 0;
      border-radius: 55px;
      padding: 10px 30px;
      width: 100%;
      text-align: center;
      font-size: 15px;
      cursor: pointer;
      transition: all ease .3s;
    }
    .plyr__controls:hover{
      color: #fff;
      background-color: #333;
    }


@media screen and (max-width: 768px) {
 .video-list .video-item{
    width: 100%;
  }

  .playType2{
    opacity: 1;
  }

}


</style>
